import { createFileRoute, redirect } from '@tanstack/react-router';
import { Complete } from '../../components/Complete/Complete';
import { validateSearch } from '../../utils/searchParams';
import { queryClient } from '../../queryClient';
import { MUTATIONS } from '../../utils/constants';
import type { SubmitResponse } from '../../graphql/mutation/submit';

export const Route = createFileRoute('/$retailer/complete')({
  component: Complete,
  validateSearch,
  beforeLoad: async ({ params, location }) => {
    const { retailer } = params;

    const search = new URLSearchParams(location.search);
    const hasRequestIdParam = search.has('request');
    const completeParam = search.get('complete');

    // Check if there's submit response data in the query cache (for regular flow)
    const submitResponse = queryClient.getQueryData<SubmitResponse>([
      MUTATIONS.SUBMIT,
    ]);
    const hasSubmitResponse = Boolean(submitResponse?.submit);

    const allow =
      hasRequestIdParam || completeParam === 'true' || hasSubmitResponse;

    if (!allow) {
      throw redirect({
        to: '/$retailer',
        params: { retailer },
        replace: true,
      });
    }
  },
});
